'use strict';

export function longmonth(inMonth) {
  var mL = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const m = parseInt(inMonth, 10) - 1; // Subtract 1 to start January at zero
  return mL[m];
}

export function shortmonth(inMonth) {
  var mS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];

  const m = parseInt(inMonth, 10) - 1; // Subtract 1 to start January at zero
  return mS[m];
}
